import tokenService from 'src/services/token/TokenService';
import userService from 'src/services/user/userService';
import CartModel from 'src/model/modules/cart.model';
import CheckoutModel from 'src/model/modules/checkout.model';
import SignInModel from 'src/model/modules/signin.model';
import OrdersModel from 'src/model/modules/orders.model';
import ListsModel from 'src/model/modules/lists.model';
import WarrantyModel from 'src/model/modules/warranty.model';
import AccountViewModel from 'src/model/modules/accountview.model';
import AddressesModel from 'src/model/modules/addresses.model';
import DashboardViewModel from 'src/model/modules/dashboardview.model';
import CreditCardModel from 'src/model/modules/creditcard.model';
import PaySimpleCheckoutTokenModel from 'src/model/modules/paysimplecheckoutoken.model';
import PaySimplePaymentModel from 'src/model/modules/paysimplepayment.model';
import Payments from 'src/model/modules/payments.model';
import InvoicesModel from 'src/model/modules/invoices.model';
import CreditsModel from 'src/model/modules/credits.model';
import ReturnsModel from 'src/model/returns.model';
import ArSummaryModel from 'src/model/modules/arSummary.model';
import MonthlyStatementModel from 'src/model/modules/monthlyStatement.model';
import SamsungOrderInvoiceViewModel from 'src/model/modules/samsungOrderInvoiceView.model';
import ClaimStatusVWModel from 'src/model/modules/claimstatusvw.model';

const success = 'accessToken' in localStorage;
const activeAccount =
  'activeAccount' in localStorage ? localStorage.getItem('activeAccount') : '';
const activeAccountCountry =
  'activeAccountCountry' in localStorage
    ? localStorage.getItem('activeAccountCountry')
    : 'powerUserActiveAccountCountry' in localStorage
    ? localStorage.getItem('powerUserActiveAccountCountry')
    : '';

const loadUserFormLocalStorage = () => {
  try {
    const storedToken = localStorage.getItem('accessToken');
    if (storedToken === null) {
      return false;
    }
    return userService.castTokenToClass(tokenService.decodeToken(storedToken));
  } catch (err) {
    return {};
  }
};

const setShouldSelectAccount = (ud: any): boolean => {
  if (ud) {
    return ud.accountId ? false : true;
  }

  return false;
};

const userData = loadUserFormLocalStorage();
const shouldSelectAccount = setShouldSelectAccount(userData);

const initialState: IInitialState = {
  signin: {
    usesTwoStepAuth: false,
    pending: false,
    shouldSelectAccount,
    shouldVerify: false,
    shouldUpdateInfo: false,
    failed: {
      hasFailed: false,
      message: ''
    },
    success,
    activeAccount,
    activeAccountCountry,
    activeAccountHasChanged: false,
    navigateToSamsungInvoicePage: false
  },
  user: {
    userData,
    userDataError: false,
    accounts: []
  },
  arSummary: {
    content: {
      currentMonthBalance: 0,
      openArBalance: 0,
      firstMonthPastDueDate: 0,
      secondMonthPastDueDate: 0,
      thirdMonthPastDueDate: 0
    },
    getArSummaryIsPending: false,
    error: {
      caller: 'string',
      error: null
    }
  },
  monthlyStatement: {
    content: {
      addressLineFour: '',
      addressLineOne: '',
      addressLineThree: '',
      addressLineTwo: '',
      adjustments: 0,
      beginningBalance: 0,
      chargesOrCredits: 0,
      customerName: '',
      customerNumber: '',
      endingBalance: 0,
      payments: 0,
      pdfPath: '',
      postalCode: '',
      statementDetails: {
        data: [],
        pageNumber: 0,
        pageSize: 0,
        totalElements: 0,
        totalPages: 0
      },
      currentTotal: 0,
      oneMonthPastTotal: 0,
      twoMonthsPastTotal: 0,
      threeMonthsPastTotal: 0,
      total: 0,
      statementDate: ''
    },
    getMonthlyStatementIsPending: false,
    error: {
      caller: 'string',
      error: null
    }
  },
  cart: {
    delivery: 'Shipping',
    deliveryLocation: null,
    deliveryLocationCode: null,
    suppliedFromCode: null,
    subTotal: '0.00',
    itemCount: 0,
    items: {},
    isPending: false,
    isPendingList: true,
    isFileStatus: false,
    success: {
      hasSucced: false,
      message: ''
    },
    error: {
      hasFailed: false,
      message: ''
    },
    updating: false,
    isDownloadingPdf: false
  },
  checkout: {
    isPending: true,
    allowedUserForExtraField: '',
    orderConfirmed: false,
    shippingMethod: {
      motcode: '',
      motdescription: ''
    },
    confirmationNumber: 0,
    checkoutCode: 0,
    cart: {
      delivery: 'Shipping',
      deliveryLocation: null,
      deliveryLocationCode: null,
      suppliedFromCode: null,
      subTotal: '0.00',
      itemCount: 0,
      items: {}
    },
    subtotal: '0.00',
    tax: '0.00',
    total: '0.00',
    defaultMOT: null,
    termsOfDelivery: null,
    softCreditHold: false,
    error: {
      hasFailed: false,
      message: ''
    },
    placingOrderProgress: false
  },
  creditcard: {
    savedCards: [],
    selectedCard: null,
    isPending: false,
    error: {
      hasFailed: false,
      message: ''
    },
    success: {
      hasSucceed: false,
      message: ''
    }
  },
  orders: {
    isPending: false,
    orders: [],
    trackingNumbers: [],
    recentOrders: [],
    pageNumber: 0,
    pageSize: 0,
    totalElements: 0,
    totalPages: 0,
    error: {
      hasFailed: false,
      message: ''
    }
  },
  lists: {
    isPending: false,
    isPendingLists: false,
    isUpdating: false,
    lists: [],
    currentList: {
      listNumber: 0,
      favorite: false,
      name: null,
      listItems: {}
    },
    error: {
      hasFailed: false,
      message: ''
    },
    success: {
      hasSucced: false,
      message: ''
    }
  },
  warranty: {
    isPending: false,
    error: {
      hasFailed: false,
      message: ''
    },
    warrantyChecks: [],
    warrantyProviders: []
  },
  accountView: {
    isPending: false,
    error: {
      hasFailed: false,
      message: ''
    },
    menuOption: 'info',
    currentPassword: '',
    newPassword: '',
    newPasswordRepeat: '',
    newPasswordValidation: {
      valid: false,
      dirty: false,
      message: ''
    },
    addressRequest: {
      address: {
        address: '',
        address2: '',
        addressId: 0,
        city: '',
        country: '',
        customerName: '',
        customerNumber: 0,
        state: '',
        zipCode: ''
      },
      addressValidation: {
        customerName: { invalid: false, message: '' },
        address: { invalid: false, message: '' },
        city: { invalid: false, message: '' },
        country: { invalid: false, message: '' },
        state: { invalid: false, message: '' },
        zipCode: { invalid: false, message: '' }
      },
      succed: false,
      failed: false
    },
    deliveryStatus: {
      accountId: '',
      deliverCompleteFlag: false
    },
    creditCardStatus: true
  },
  dashboardView: {
    isPending: false,
    error: {
      hasFailed: false,
      message: ''
    },
    menuOption: 'switch',
    powerUsers: [],
    echeckDisabledUsers: [],
    hasSucceed: false,
    currentPassword: '',
    newPassword: '',
    unlockUser: '',
    newPasswordRepeat: '',
    newPasswordValidation: {
      valid: false,
      dirty: false,
      message: ''
    }
  },
  addresses: {
    isPending: false,
    error: {
      hasFailed: false,
      message: ''
    },
    addresses: []
  },
  invoices: {
    data: [],
    datesFilter: null,
    sortFilter: { type: 'invoiceDate', order: 'desc' },
    statusFilter: null,
    orderFilter: null,
    invoiceFilter: null,
    nardFilter: null,
    orderNumberFilter: null,
    poNumberFilter: null,
    pageNumber: 0,
    pageSize: 0,
    totalElements: 0,
    totalPages: 0,
    totalCredit: 0,
    totalDebit: 0,
    totalCreditoriginal: 0,
    totalDebitoriginal: 0,
    totalCreditmanual: 0,
    totalDebitmanual: 0,
    creditTotalElements: 0,
    getInvoicesIsPending: false,
    error: {
      caller: 'string',
      hasFailed: false,
      message: ''
    },
    success: {
      hasSucceed: false,
      message: ''
    },
    manualerror: {
      caller: 'string',
      hasFailed: false,
      message: ''
    },
    manualsuccess: {
      hasSucceed: false,
      message: ''
    },
    selectedInvoices: [],
    isInvoiceActive: [],
    originalInvoicedata: [],
    oldestInvoicedata: [],
    selectcreditInvoicedata: [],
    selectedCreditInvoices: [],
    selectedClaims: []
  },
  paySimpleCheckoutToken: {
    isPending: false,
    JwtToken: '',
    Expiration: '',
    url: '',
    error: {
      hasFailed: false,
      message: ''
    }
  },
  paySimplePayment: {
    authorized: false,
    trackingNumber: '',
    errorMessage: null,
    isPending: false,
    error: {
      hasFailed: false,
      message: ''
    },
    showStatusModal: false
  },
  payments: {
    data: [],
    pageNumber: 0,
    pageSize: 0,
    totalElements: 0,
    totalPages: 0,
    isPending: false,
    error: {
      hasFailed: false,
      message: ''
    }
  },
  credits: {
    payments: [],
    statusFilter: null,
    pageNumber: 0,
    pageSize: 0,
    totalElements: 0,
    totalPages: 0,
    isPending: false,
    error: {
      hasFailed: false,
      message: ''
    }
  },
  returns: {
    partsToReturn: [],
    rmaList: [],
    eligibleData: {
      data: [],
      pageNumber: 0,
      pageSize: 0,
      totalElements: 0,
      totalPages: 0
    },
    eligibleCoreData: {
      data: [],
      pageNumber: 0,
      pageSize: 0,
      totalElements: 0,
      totalPages: 0
    },
    statusData: {
      data: [],
      pageNumber: 0,
      pageSize: 0,
      totalElements: 0,
      totalPages: 0
    },
    returnAlert: {
      show: false,
      message: '',
      type: ''
    },
    returnStatusAlert: {
      show: false,
      message: '',
      type: ''
    },
    isPending: false,
    isDownloadingPdf: false,
    error: {
      hasError: false,
      message: ''
    }
  },
  samsungOrderInvoiceView: {
    samsungSearchForm: {
      action: 'SEARCH',
      productCode: '',
      palletRegNumber: '',
      customerCode: '',
      orderNumber: '',
      orderReference: '',
      ticket: '',
      dateFrom: null,
      dateTo: null
    },
    samsungOrderInvoices: [],
    samsungOrderResultData: [],
    pageInformation: {
      pageNumber: 0,
      pageSize: 20,
      totalElements: 20,
      totalPages: 1
    }
  },
  claimstatus: {
    data: [],
    datesFilter: null,
    sortFilter: { type: 'invoiceDate', order: 'desc' },
    statusFilter: null,
    orderFilter: null,
    invoiceFilter: null,
    nardFilter: null,
    orderNumberFilter: null,
    poNumberFilter: null,
    pageNumber: 0,
    pageSize: 0,
    totalElements: 0,
    totalPages: 0,
    totalCredit: 0,
    totalDebit: 0,
    totalCreditoriginal: 0,
    totalDebitoriginal: 0,
    totalCreditmanual: 0,
    totalDebitmanual: 0,
    creditTotalElements: 0,
    getInvoicesIsPending: false,
    error: {
      caller: 'string',
      hasFailed: false,
      message: ''
    },
    success: {
      hasSucceed: false,
      message: ''
    },
    manualerror: {
      caller: 'string',
      hasFailed: false,
      message: ''
    },
    manualsuccess: {
      hasSucceed: false,
      message: ''
    },
    selectedInvoices: [],
    isInvoiceActive: [],
    originalInvoicedata: [],
    oldestInvoicedata: [],
    selectcreditInvoicedata: [],
    selectedCreditInvoices: []
  }
};

export interface IInitialState {
  signin: SignInModel;
  user: {
    userData: any;
    userDataError: boolean;
    accounts: any[];
  };
  cart: CartModel;
  checkout: CheckoutModel;
  creditcard: CreditCardModel;
  orders: OrdersModel;
  lists: ListsModel;
  warranty: WarrantyModel;
  accountView: AccountViewModel;
  dashboardView: DashboardViewModel;
  addresses: AddressesModel;
  paySimpleCheckoutToken: PaySimpleCheckoutTokenModel;
  paySimplePayment: PaySimplePaymentModel;
  payments: Payments;
  credits: CreditsModel;
  invoices: InvoicesModel;
  returns: ReturnsModel;
  arSummary: ArSummaryModel;
  monthlyStatement: MonthlyStatementModel;
  samsungOrderInvoiceView: SamsungOrderInvoiceViewModel;
  claimstatus: ClaimStatusVWModel;
}

export default initialState;
